import { StorageKeys } from "@utils/enums";

const RECENTLY_VIEWED_KEY = StorageKeys.RecentlyViewedProducts;

export const addProductToRecentlyViewed = (sku: string): void => {
    if (!localStorage.getItem(RECENTLY_VIEWED_KEY)) {
        localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify([sku]));
    } else {
        const recentlyViewedArray = getRecentlyViewed(sku);
        recentlyViewedArray.unshift(sku);
        localStorage.setItem(
            RECENTLY_VIEWED_KEY,
            JSON.stringify(firstTwentyEntries(recentlyViewedArray)),
        );
    }
};

export const getRecentlyViewed = (sku?: string): Array<string> => {
    const localStorageItem = localStorage.getItem(RECENTLY_VIEWED_KEY);
    if (!localStorageItem) {
        return [];
    } else {
        const recentlyViewedArray: Array<string> = JSON.parse(localStorageItem);
        if (sku) {
            return firstTwentyEntries(recentlyViewedArray).filter(
                (product: string) => product !== sku,
            );
        }

        return firstTwentyEntries(recentlyViewedArray);
    }
};

const firstTwentyEntries = (array: Array<string>) => {
    return array.slice(0, 20);
};

export const removeItemFromRecentlyViewed = (sku: string) => {
    const localStorageItem = localStorage.getItem(RECENTLY_VIEWED_KEY);
    if (localStorageItem) {
        const recentlyViewedArray = JSON.parse(localStorageItem);
        const newArray = recentlyViewedArray.filter(
            (product: string) => product !== sku,
        );
        localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(newArray));
    }
};

export const removeRecentlyViewed = () => {
    if (localStorage.getItem(RECENTLY_VIEWED_KEY)) {
        localStorage.removeItem(RECENTLY_VIEWED_KEY);
    }
};
